var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M500.87,256l8.959-33.391c-1.488-11.381-3.72-22.529-6.647-33.391H233.739V0.974 c-11.36,0.978-22.505,2.707-33.391,5.121l-44.522,27.296l-22.261-2.247c-11.715,6.392-22.876,13.672-33.391,21.751v136.322H8.819 c-2.927,10.862-5.159,22.01-6.647,33.391L11.13,256l-8.959,33.391c1.488,11.381,3.72,22.529,6.647,33.391h91.355v136.322 c10.515,8.08,21.677,15.359,33.391,21.751l33.391-2.247l33.391,27.296c10.887,2.413,22.032,4.142,33.391,5.121V322.783h269.442 c2.927-10.862,5.159-22.01,6.647-33.391L500.87,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M509.833,222.609H200.349h-0.001V6.085c-23.658,5.246-46.087,13.749-66.783,25.042v191.481l0,0H2.167 C0.744,233.539,0,244.683,0,256s0.744,22.461,2.167,33.391h131.397h0.001v191.481c20.696,11.292,43.125,19.797,66.783,25.042 V289.394v-0.002h309.485C511.256,278.461,512,267.317,512,256S511.256,233.539,509.833,222.609z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFo);
export default __webpack_public_path__ + "static/media/fo.23357a435870b1b0f47b4a4ecff8476f.svg";
export { ForwardRef as ReactComponent };